import { render, staticRenderFns } from "./General_Terms.vue?vue&type=template&id=4a312d3d&"
import script from "./General_Terms.vue?vue&type=script&lang=js&"
export * from "./General_Terms.vue?vue&type=script&lang=js&"
import style0 from "./General_Terms.vue?vue&type=style&index=0&id=4a312d3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports